import { Button, Center, Group, Image, Paper, Text } from '@mantine/core'
import { observer } from 'mobx-react-lite'
import { Link } from 'wouter'

import logo from '#assets/images/blue-logo.svg'
import { FaIcon } from '#components/FaIcon'
import { useMst } from '#state'
import { IOrg } from '#state/types'

import styles from './DashboardHeader.module.css'

type DashboardHeaderProps = {
  org: IOrg
  isAdmin: boolean
}

export const DashboardHeader = observer(function DashboardHeader({
  org,
  isAdmin,
}: DashboardHeaderProps) {
  const { trackLinkClicked } = useMst()

  const trackDashboardLink = (to: string) => {
    trackLinkClicked({
      source: 'dashboard',
      linkType: 'internal',
      to,
    })
  }

  return (
    <>
      <Paper bg="dark.7" py={10} px={20} radius={0}>
        <Center>
          <Image src={logo} w={140} />
        </Center>
      </Paper>
      <Paper className={styles.wrapper} pt={15} pb={15} px={20} radius={0}>
        <Group
          className={styles.header}
          maw={1000}
          mb={0}
          mt={0}
          mx="auto"
          w="100%"
          justify="space-between"
        >
          <Text fw="bold">{org.name}</Text>
          <Group gap={5} justify="center">
            <Button
              component={Link}
              href="/settings/org"
              leftSection={<FaIcon icon="fa-gear" />}
              variant="default"
              size="md"
              bd="none"
              onClick={() => trackDashboardLink('settings')}
            >
              Settings
            </Button>
            <Button
              component={Link}
              href="/settings/org/members"
              leftSection={<FaIcon icon="fa-users" />}
              variant="default"
              size="md"
              bd="none"
              onClick={() => trackDashboardLink('members')}
            >
              Members
            </Button>
            {isAdmin && (
              <Button
                component={Link}
                href="/settings/org/permissions"
                leftSection={<FaIcon icon="fa-user-lock" />}
                variant="default"
                size="md"
                bd="none"
                onClick={() => trackDashboardLink('permissions')}
              >
                Permissions
              </Button>
            )}
          </Group>
        </Group>
      </Paper>
    </>
  )
})
